import {Toast} from "vant";

export default {
  install(Vue) {
    // 复制
    Vue.directive('copy', {
      bind(el, { value }) {
        if(!value || value == 'undefined' || value == null){
          el.style.display = 'none'
        }
        el.$value = value
        el.handler = () => {
          Vue.prototype.$copyText(`${el.$value}`).then(
            () => {
              Toast('复制成功！')
            },
            () => {
              Toast('复制失败')
            },
          )
        }
        el.addEventListener('click', el.handler) // 绑定点击事件
      },
      // 当传进来的值更新的时候触发
      componentUpdated(el, { value }) {
        el.$value = value
      },
      // 指令与元素解绑的时候，移除事件绑定
      unbind(el) {
        el.removeEventListener('click', el.handler)
      },
    })
  }
}
